import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  type CoverageZone,
  type UpdateZoneParams,
} from "../../../domain/entities/coverage";
import { type ZonesDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const updateZone = createAsyncThunk<
  CoverageZone,
  UpdateZoneParams,
  { dispatch: ZonesDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.UPDATE_ZONE, async (params, { extra }) => {
  return await extra.zonesRepo.updateZone(params);
});
